module.exports = __webpack_public_path__ + "img/Avatar-49.de7f57a5.svg";